<script lang="ts">
	import { onMount } from 'svelte';
	import { cookiesConsent, setConsent } from '$stores/cookiesConsent';
	import { page } from '$app/stores';

	let dialog: HTMLDialogElement;
	const exclude = ['/cookies', '/privacy', '/terms'];

	onMount(() => {
		// This code runs only in the browser, so it's safe to access localStorage here
		if (
			!localStorage.getItem('cookiesConsent') ||
			localStorage.getItem('cookiesConsent') === 'false'
		) {
			setConsent(false);
		} else {
			setConsent(true);
		}
	});

	$: if (($cookiesConsent || exclude.includes($page.url.pathname)) && dialog) {
		dialog.close();
	} else if (
		$cookiesConsent === false &&
		dialog &&
		!exclude.includes($page.url.pathname)
	) {
		dialog.showModal();
	}

	function stopDialogClosingOnEscapePress(e: KeyboardEvent) {
		if (e.key === 'Escape') {
			e.preventDefault();
		}
	}
</script>

<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
<dialog
	bind:this={dialog}
	aria-labelledby="cookiesDialogTitle"
	aria-describedby="cookiesDialogDesc"
	on:keydown={(e) => stopDialogClosingOnEscapePress(e)}
>
	<div class="fixed inset-x-0 bottom-0 flex flex-row rounded-t-lg bg-white p-4">
		<div>
			<h2 id="cookiesDialogTitle" class="text-lg font-bold">
				<span class="fa-duotone fa-cookie-bite text-logoFontPurple"></span> Cookies
				Consent
			</h2>
			<p id="cookiesDialogDesc" class="mt-2 text-sm">
				We use cookies to improve your experience. By continuing, you agree to
				our use of cookies.
			</p>
			<p class="mt-2 text-xs">
				To learn more about our use of cookies and what you are agreeing to by
				pressing the accept button, please visit our <a
					class="font-medium hover:text-gray-600 focus:text-gray-600"
					href="/privacy">Privacy Policy</a
				>, our
				<a
					class="font-medium hover:text-gray-600 focus:text-gray-600"
					href="/terms">Terms and Conditions</a
				>, and our
				<a
					class="font-medium hover:text-gray-600 focus:text-gray-600"
					href="/cookies">Cookies Policy</a
				>
			</p>
		</div>
		<!-- svelte-ignore a11y-autofocus -->
		<button
			class="my-auto ml-auto block w-fit rounded bg-logoBackgroundBlue px-5 py-3 text-sm text-gray-100 transition hover:bg-logobackgroundBlueRgba focus:bg-logobackgroundBlueRgba disabled:cursor-not-allowed disabled:bg-gray-300"
			autofocus
			on:click={() => setConsent(true)}
		>
			Accept
		</button>
	</div>
</dialog>
